<template>
  <form-wrapper>
    <b-form @submit="onSubmit">
      <h2 class="text-center">
        Add Question
      </h2>

      <edit-question
        v-model="question"
        :knowledgecheck="innerModel"
        @saved="onSubmit"
        @canceled="onCancel"
      ></edit-question>

    </b-form>

  </form-wrapper>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'
import editQuestion from '../questions/edit'
import formWrapper from '@/components/common/form/form-wrapper'

const defaultQuestion = {
  type: 'radio',
  order: 0,
  text: 'default text',
  choices: [
    {
      label: 'Choice 1',
      value: '1',
      is_answer: true,
      order: 1
    },
    {
      label: 'Choice 2',
      value: '2',
      is_answer: false,
      order: 2
    }
  ]
}

export default {
  components:{
    editQuestion,
    formWrapper
  },
  props:{
    value: {type:Object, default:null}
  },
  data(){
    return {
      innerModel: {},
      question: _.cloneDeep(defaultQuestion),
      saving: false,
      fetching: false
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapState('components', {
      component: 'current'
    }),
    disabled(){
      return this.fetching || this.saving
    }
  },
  watch: {
    value(val){
      if(val != this.innerModel){
        this.innerModel = val
      }
    }
  },
  methods:{
    ...mapActions('components', {
      refresh: 'show'
    }),
    onSubmit(q) {
      this.$emit('added', _.cloneDeep(q))
      this.resetForm()
    },
    onCancel() {
      this.$emit('cancel')
      this.resetForm()
    },
    resetForm(){
      this.question = _.cloneDeep(defaultQuestion)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/components/add-question.vue